import React from 'react';
import {
    AppLayout,
    Header,
    SideNavigation,
    Container,
    ContentLayout,
    Cards,
    Box,
    SpaceBetween,
    Link,
    Button
} from '@cloudscape-design/components';
import MeetingsPage from './MeetingsPage';
import GetStarted from './GetStartedPage';
import {BreadcrumbGroup} from "@cloudscape-design/components";
import ArchitectureDiagram from '../images/ArchitectureDiagram.png'
import { NavigationSide } from "./Navigation";


function Documentation() {
  return (
      <AppLayout
        navigation={<NavigationSide activeHref="/architecture"/>}
        content={<MainContent />}
        header={<PageHeader />}
        contentType="dashboard"
        toolsHide={true}
      />
  );
}
function Navigation({ activeHref }) {
  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ text: 'AWS Eloquence', href: '/' }}
      items={[
        { type: 'link', text: 'Learn More', href: '/learnmore' },
        { type: 'link', text: 'Get Started', href: '/getstarted' },
        { type: 'link', text: 'My Meetings', href: '/meetings'},
        { type: 'link', text: 'Meet the Team', href: '/meettheteam'},
        { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
        { type: 'divider' },
        { type: 'link', text: 'Documentation', href: '/documentation' },
      ]}
    />
  );
}

function MainContent() {
    return (
    <>
    <BreadcrumbGroup
      items={[
        { text: "Home", href: "/" },
        { text: "Architecture Diagram", href: "/architecture" },
      ]}
      ariaLabel="Breadcrumbs"
    />
    <br></br>

      <ContentLayout
        defaultPadding
        // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
        headerVariant="high-contrast"
        maxContentWidth={2000}
        disableOverlap
        header={
          <SpaceBetween size="m">
          <Header variant="h1" description="View our Architecture">AWS Eloquence Architecture Diagram</Header>
        </SpaceBetween>
        }
      >
        <br></br>
        <Container>
        <div className="container-wrapper">
          {/* <h2>Track Progress</h2>
          <p>Visualize your history</p> */}
          <div>
          <div className="image-wrapper" style={{
              width: '100%',
              maxWidth: '1200px',
              margin: '0 auto',
              height: 'calc(100vh - 200px)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
          <img src={ArchitectureDiagram} alt="Architecture Diagram" />
          </div>
          </div>
        </div></Container>

    </ContentLayout>
    </>


    
  );
}

function PageHeader() {
  return (
    <Header
      variant="h1"
      actions={
        <div>
          {/* Add any header actions here */}
        </div>
      }
    >
      My Application
    </Header>
  );
}
export default Documentation;
